import React, { useEffect, useRef, useState } from "react";
import "./ChatbotActionDrawer.css";
import * as FeatherIcon from "react-feather";
import { useUser } from "../../../../context/UserContext";
import { getChatHistoryChips } from "../../../../services/iqApiV2";
import { getCurrentTime } from "../../../Helper/currDataTime";
import { useParams } from "react-router-dom";

const truncateWords = (str, num) => {
  if (!str) return "";
  const words = str.split(" ");
  return words.length > num ? words.slice(0, num).join(" ") + "..." : str;
};



const ChatbotActionDrawer = ({
  open,
  onClose,
  children,
  width = "320px",
  setDrawerOpen,
  setchatSessionId,
  setChat,
  setSessionId,
  sessionId,
  setChatAccAndClient
}) => {
  const { accountName, clientName } = useParams();
  const { user } = useUser();
  const uniqueKey = `${Date.now()}_${user?.id}`;
  const handleNewChatInit=()=>{
     setChatAccAndClient({
                        accountName:accountName||"",
                        clientName:clientName||""
                      })
        if (user?.firstname ) {
      setChat([
        {
          type: "bot",
          content: ` <p> Hi <strong>${user.firstname}</strong>, how can I help you today?</p>`
,
          time: getCurrentTime(),
          streaming: false,
        },
      ]);
          setchatSessionId(null)
          setSessionId(uniqueKey)
          setDrawerOpen(false)
          setHistData((prev=>[{_id:uniqueKey,time:getCurrentTime(),heading:"new chat"},...prev]))
          setchatSessionId(uniqueKey)
    }
  }
  const [searchTerm, setSearchTerm] = useState("");
  const drawerRef = useRef();

  const [histData, setHistData] = useState();
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, onClose]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await getChatHistoryChips();
        console.log("Chat History Response:", resp);
        setHistData(resp);
      } catch (error) {
        console.error("Error fetching chat history:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className={`chatbot-drawer-wrapper ${open ? "open" : ""}`}>
      <div className="chatbot-drawer-panel" ref={drawerRef} style={{ width }}>
        <div
          style={{
            display: "flex",
            height: "100%",
            width:"100%",
            flexDirection: "column",
            padding: "0.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              height: "10%",
              fontSize: "1rem",
              fontSize: "1rem",
              fontWeight: "600",
              borderBottom: "1px solid rgba(11, 39, 70, 0.13)",
              marginBottom: "1rem",
            }}
          >
            <div className="chatbot_hist_search_box">
              <div className="chatbot_hist_search_box">
                <FeatherIcon.Search className="search-icon" />
                <input
                  type="text"
                  className="chatbot_hist_search_bar"
                  placeholder="Search..."
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <span title="new chat">
                {" "}
                <FeatherIcon.Edit
                  onClick={() => {
                    handleNewChatInit();
                  }}
                  style={{
                    color: "#4e6bca",

                    width: "1.2rem",
                    marginLeft: "1rem",
                  }}
                />
              </span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              height: "90%",
              width: "100%",
            }}
          >
            <ul className="hist-ul-comp">
              {histData
                ?.filter((item) =>
                  item?.heading
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase())
                )
                ?.map((item, idx) => {
                  console.log(sessionId, item?._id)
                  return <li
                    className={`hist-li-comp${sessionId === item?._id ? " selected" : ""}`}
                    key={idx}
                    title={item?.heading}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setchatSessionId(item?._id);
                      setChatAccAndClient({
                        accountName:item?.account_name||"",
                        clientName:item?.client_name||""
                      })
                      setDrawerOpen(false);
                    }}
                  >
                    {truncateWords(item?.heading, 9)}
                  </li>
                })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotActionDrawer;
